<template>
  <div class="adminBoard">
    <v-card>
      <v-container>
        <v-card class="mb-4">
          <v-col>
            <strong>BACTERIA_GROWTH</strong>
            <v-row>
              <v-col> Photo: </v-col>
              <v-col> </v-col>
              <v-col>
                <v-btn @click="downloadAllPhotos">Download</v-btn>
              </v-col>
              <v-col>
                <v-btn @click="removeAllPhotos" color="error">Remove</v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-card>
        <v-card class="mb-4">
          <v-col>
            <strong>RESPIRATION</strong>
            <v-row>
              <v-col> Data: </v-col>
              <v-col>
                <v-btn @click="popRecord('RESPIRATION')">
                  Start/Stop
                </v-btn>
              </v-col>
              <v-col>
              </v-col>
              <v-col>
                <v-btn @click="popData('RESPIRATION')">Download/Remove</v-btn>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row>
              <v-col> Setup: </v-col>
              <v-col>
                <v-btn @click="popCondition('RESPIRATION')">Condition</v-btn>
              </v-col>
              <v-col>
                <v-btn @click="popPhoto('RESPIRATION')">Photo</v-btn>
              </v-col>
              <v-col> </v-col>
            </v-row>
          </v-col>
        </v-card>
        <v-card class="mb-4">
          <v-col>
            <strong>PHOTOSYNTHESIS</strong>
            <v-row>
              <v-col> Data: </v-col>
              <v-col>
                <v-btn @click="popRecord('PHOTOSYNTHESIS')">
                  Start/Stop
                </v-btn>
              </v-col>
              <v-col>
                <v-btn @click="popLight('PHOTOSYNTHESIS')">Light On/Off</v-btn>
              </v-col>
              <v-col>
                <v-btn @click="popData('PHOTOSYNTHESIS')">Download/Remove</v-btn>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row>
              <v-col> Setup: </v-col>
              <v-col>
                <v-btn @click="popCondition('PHOTOSYNTHESIS')">Condition</v-btn>
              </v-col>
              <v-col>
                <v-btn @click="popPhoto('PHOTOSYNTHESIS')">Photo</v-btn>
              </v-col>
              <v-col> </v-col>
            </v-row>
          </v-col>
        </v-card>
      </v-container>
    </v-card>

    <input
      ref="file"
      type="file"
      accept="image/*"
      @change="uploadPhoto()"
      hidden
    />

    <v-dialog v-model="lightDialog" width="600" persistent>
      <v-card>
        <v-card-title class="headline grey lighten-2">
          {{ selected_experiment }} - Light On/Off
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>Set 0 (Room 1)
              <br>
              <div v-if="api.lights['set_0'] == 0">
                Light is OFF.
              </div>
              <div v-else>
                Light is ON.
              </div>
            </v-col>
            <v-col v-if="api.lights['set_0'] == 0">
              <v-btn @click="lightOn(selected_experiment, 'set_0')" color="accent">Turn on</v-btn>
            </v-col>
            <v-col v-else>
              <v-btn @click="lightOff(selected_experiment, 'set_0')" color="warning">Turn off</v-btn>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row>
            <v-col>Set 1(Room 2)
              <br>
              <div v-if="api.lights['set_1'] == 0">
                Light is OFF.
              </div>
              <div v-else>
                Light is ON.
              </div>
            </v-col>
            <v-col v-if="api.lights['set_1'] == 0">
              <v-btn @click="lightOn(selected_experiment, 'set_1')" color="accent">Turn on</v-btn>
            </v-col>
            <v-col v-else>
              <v-btn @click="lightOff(selected_experiment, 'set_1')" color="warning">Turn off</v-btn>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row>
            <v-col>Set 2 (Room 3)
              <br>
              <div v-if="api.lights['set_2'] == 0">
                Light is OFF.
              </div>
              <div v-else>
                Light is ON.
              </div>
            </v-col>
            <v-col v-if="api.lights['set_2'] == 0">
              <v-btn @click="lightOn(selected_experiment, 'set_2')" color="accent">Turn on</v-btn>
            </v-col>
            <v-col v-else>
              <v-btn @click="lightOff(selected_experiment, 'set_2')" color="warning">Turn off</v-btn>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row>
            <v-col>Set 3 (Room 4)
              <br>
              <div v-if="api.lights['set_3'] == 0">
                Light is OFF.
              </div>
              <div v-else>
                Light is ON.
              </div>
            </v-col>
            <v-col v-if="api.lights['set_3'] == 0">
              <v-btn @click="lightOn(selected_experiment, 'set_3')" color="accent">Turn on</v-btn>
            </v-col>
            <v-col v-else>
              <v-btn @click="lightOff(selected_experiment, 'set_3')" color="warning">Turn off</v-btn>
            </v-col>
          </v-row>
          <v-divider></v-divider>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="closeDialog"> Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dataDialog" width="600" persistent>
      <v-card>
        <v-card-title class="headline grey lighten-2">
          {{ selected_experiment }} - Download/Remove Data
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>Set 0 (Room 1)</v-col>
              <v-col>
                <v-btn @click="downloadCSV(selected_experiment, 'set_0')">Download</v-btn>
              </v-col>
              <v-col>
                <v-btn @click="promptRemove(selected_experiment, 'set_0')" color="error"
                  >Remove</v-btn
                >
              </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row>
            <v-col>Set 1(Room 2)</v-col>
              <v-col>
                <v-btn @click="downloadCSV(selected_experiment, 'set_1')">Download</v-btn>
              </v-col>
              <v-col>
                <v-btn @click="promptRemove(selected_experiment, 'set_1')" color="error"
                  >Remove</v-btn
                >
              </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row>
            <v-col>Set 2 (Room 3)</v-col>
            <v-col>
              <v-btn @click="downloadCSV(selected_experiment, 'set_2')">Download</v-btn>
            </v-col>
            <v-col>
              <v-btn @click="promptRemove(selected_experiment, 'set_2')" color="error"
                >Remove</v-btn
              >
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row>
            <v-col>Set 3 (Room 4)</v-col>
            <v-col>
              <v-btn @click="downloadCSV(selected_experiment, 'set_3')">Download</v-btn>
            </v-col>
            <v-col>
              <v-btn @click="promptRemove(selected_experiment, 'set_3')" color="error"
                >Remove</v-btn
              >
            </v-col>
          </v-row>
          <v-divider></v-divider>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="closeDialog"> Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="imageDialog" width="680" persistent>
      <v-card>
        <v-card-title class="headline grey lighten-2"
          >{{ selected_experiment }} - Experiment Photo
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <v-select
                :items="equipment_ids" item-text="text" item-value="value" v-model="equipment_id"
                label="Equipment ID" @change="getImageSrc(selected_experiment, equipment_id, selected_light);"
              ></v-select>
            </v-col>
            <v-col>
              <v-select
                :items="light_status" item-text="text" item-value="value" v-model="selected_light"
                label="Light Status" @change="getImageSrc(selected_experiment, equipment_id, selected_light);"
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text>
          <v-img :src="api.img_src" fluid :disabled="image_select==false"/>
            Selected: {{ selected_experiment }}
            <br>
            Equipment: {{ equipment_id }}
            <br>
            Light Status: {{ selected_light }}
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-btn color="primary" text @click="uploadFile">
            Upload Photo</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="removePhoto(selected_experiment, equipment_id, selected_light)"
            >Remove Photo</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="closeDialog"> Hide</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="recordDialog" width="600" persistent>
      <v-card>
        <v-card-title class="headline grey lighten-2">
          {{ selected_experiment }} - Start/Stop Record
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>Set 0 (Room 1)
              <br>
              <div v-if="api.records['set_0'] == 0">
                Data is NOT taking.
              </div>
              <div v-else>
                Taking Data.
              </div>
            </v-col>
            <v-col v-if="api.records['set_0'] == 0">
              <v-btn @click="startRecord(selected_experiment, 'set_0')" color="accent">Start Record</v-btn>
            </v-col>
            <v-col v-else>
              <v-btn @click="promptStop(selected_experiment, 'set_0')" color="warning">Stop Record</v-btn>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row>
            <v-col>Set 1(Room 2)
              <br>
              <div v-if="api.records['set_1'] == 0">
                Data is NOT taking.
              </div>
              <div v-else>
                Taking Data.
              </div>
            </v-col>
            <v-col v-if="api.records['set_1'] == 0">
              <v-btn @click="startRecord(selected_experiment, 'set_1')" color="accent">Start Record</v-btn>
            </v-col>
            <v-col v-else>
              <v-btn @click="promptStop(selected_experiment, 'set_1')" color="warning">Stop Record</v-btn>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row>
            <v-col>Set 2 (Room 3)
              <br>
              <div v-if="api.records['set_2'] == 0">
                Data is NOT taking.
              </div>
              <div v-else>
                Taking Data.
              </div>
            </v-col>
            <v-col v-if="api.records['set_2'] == 0">
              <v-btn @click="startRecord(selected_experiment, 'set_2')" color="accent">Start Record</v-btn>
            </v-col>
            <v-col v-else>
              <v-btn @click="promptStop(selected_experiment, 'set_2')" color="warning">Stop Record</v-btn>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row>
            <v-col>Set 3 (Room 4)
              <br>
              <div v-if="api.records['set_3'] == 0">
                Data is NOT taking.
              </div>
              <div v-else>
                Taking Data.
              </div>
            </v-col>
            <v-col v-if="api.records['set_3'] == 0">
              <v-btn @click="startRecord(selected_experiment, 'set_3')" color="accent">Start Record</v-btn>
            </v-col>
            <v-col v-else>
              <v-btn @click="promptStop(selected_experiment, 'set_3')" color="warning">Stop Record</v-btn>
            </v-col>
          </v-row>
          <v-divider></v-divider>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="closeDialog"> Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="confirmDialog" width="600" persistent>
      <v-card>
        <v-card-title class="headline grey lighten-2">
          {{ experiment }}-{{ equipment_id }}
        </v-card-title>
        <v-card-text>
          <v-alert class="mt-4" type="error"> Stop Recording data? </v-alert>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="confirmStop"> Confirm</v-btn>
          <v-btn color="primary" text @click="cancelStop"> Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="confirmRemoveDialog" width="600" persistent>
      <v-card>
        <v-card-title class="headline grey lighten-2">
          {{ experiment }} - {{ equipment_id }}
        </v-card-title>
        <v-card-text>
          <v-alert class="mt-4" type="error"> Remove experiment data? </v-alert>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="confirmRemove"> Confirm</v-btn>
          <v-btn color="primary" text @click="cancelRemove"> Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="conditionDialog">
      <v-dialog v-model="conditionDialog" width="680" persistent>
        <v-card>
          <v-card-title class="headline grey lighten-2"
            >{{ selected_experiment }} - Condition
          </v-card-title>
          <v-card-text>
            <v-select
              :items="equipment_ids" item-text="text" item-value="value" v-model="equipment_id"
              label="Equipment ID" @change="getCondition(equipment_id);"
            ></v-select>
          </v-card-text>
          <v-simple-table v-if="condition_select">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Key</th>
                  <th class="text-left">Value</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in api.condition" :key="item.key">
                  <td>
                    <v-text-field
                      v-bind:value="item.key" dense outlined clearable class="input" ref="input">
                      </v-text-field>
                  </td>
                  <td>
                    <v-text-field
                      v-bind:value="item.value" dense outlined clearable class="input" ref="input">
                      </v-text-field>
                  </td>
                </tr>
                <tr v-for="n in 5-api.condition.length" :key="n">
                  <td>
                    <v-text-field dense outlined clearable class="input" ref="input">

                    </v-text-field>
                  </td>
                  <td>
                    <v-text-field dense outlined clearable class="input" ref="input">

                    </v-text-field>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <v-divider></v-divider>

          <v-card-actions>
            <v-btn color="primary" text @click="generateChanges">Save</v-btn>
            <v-spacer></v-spacer>            
            <v-btn color="primary" text @click="closeDialog"> Hide</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { Admin_APIService } from "@/services/Admin_APIService";
import ExperimentBasic from "@/services/ExperimentBasic";
import { Experiment_APIService } from "@/services/Experiment_APIService";
const apiService = new Admin_APIService(process.env.VUE_APP_BASE_URL);
const expService = new Experiment_APIService(process.env.VUE_APP_BASE_URL);
export default {
  name: "AdminBoard",
  props: {},
  mixins: [ExperimentBasic],
  data: function () {
    return {
      headers: [
        { text: 'Key', value: 'key' },
        { text: 'Value', value: 'value' },
      ],
      arr:[],
      experiment: "",
      equipment_id: "",
      confirmDialog: false,
      confirmRemoveDialog: false,
      respiration_start: {
        set_0: 0,
        set_1: 0,
        set_2: 0,
        set_3: 0,
      },
      photosynthesis_start: {
        set_0: 0,
        set_1: 0,
        set_2: 0,
        set_3: 0,
      },
      imageDialog: false,
      conditionDialog: false,
      condition_select: false,
      image_select:false,
      dataDialog: false,
      lightDialog: false,      
      recordDialog: false,
      selected_experiment: "",
      selected_light: "",
      img_src: {
        on: '',
        off: '',
      },
      equipment_ids: [
        {
          text: "Set 0 (Room 1)",
          value: "set_0",
        },
        {
          text: "Set 1 (Room 2)",
          value: "set_1",
        },
        {
          text: "Set 2 (Room 3)",
          value: "set_2",
        },
        {
          text: "Set 3 (Room 4)",
          value: "set_3",
        },
      ],
      light_status: [
        {
          text: "Light On",
          value: "1",
        },
        {
          text: "Light Off",
          value: "0",
        },
      ],
      api: {
        value: "",
        value_got_at: null,
        value_set_at: null,
        camera_0: "",
        condition: [],
        img_src: "",
        records: {
          set_0: 0,
          set_1: 0,
          set_2: 0,
          set_3: 0,
        },
        lights: {
          set_0: '',
          set_1: '',
          set_2: '',
          set_3: '',
        },
      },
    };
  },
  computed: {},
  mounted: function () {
    var self = this;
    self.getBoardExperimentStart("RESPIRATION", "set_0");
    self.getBoardExperimentStart("RESPIRATION", "set_1");
    self.getBoardExperimentStart("RESPIRATION", "set_2");
    self.getBoardExperimentStart("RESPIRATION", "set_3");
  },
  methods: {
    downloadAllPhotos() {
      var self = this;
      apiService.downloadAllBacteriaPhotos(
        "BACTERIA_GROWTH",
        "set_0",
        function () {
          window.open(
            process.env.VUE_APP_BASE_URL +
              "/api/experiment/storage/" +
              "BACTERIA_GROWTH" +
              "-" +
              "set_0" +
              "-archive.zip"
          );
        }
      );
    },
    removeAllPhotos() {
      var self = this;
      apiService.removeAllBacteriaPhotos(
        "BACTERIA_GROWTH",
        "set_0",
        function () {
          alert("Removed All photos");
        }
      );
    },
    popPhoto(experiment) {
      var self = this;
      self.selected_experiment = experiment;
      self.imageDialog = true;
    },
    popData(experiment) {
      var self = this;
      self.selected_experiment = experiment;
      self.dataDialog = true;
    },
    popLight(experiment) {
      var self = this;      
      self.getBoardExperimentLight(experiment, "set_0");
      self.getBoardExperimentLight(experiment, "set_1");
      self.getBoardExperimentLight(experiment, "set_2");
      self.getBoardExperimentLight(experiment, "set_3");
      setTimeout(function(){
        if (experiment == "RESPIRATION") {
          self.selected_experiment = "RESPIRATION";
          self.lightDialog = true;
        } else if (experiment == "PHOTOSYNTHESIS") {
          self.selected_experiment = "PHOTOSYNTHESIS";
          self.lightDialog = true;
        } else {
          self.selected_experiment = "";
          self.lightDialog = false;
        }
      },200);
    },
    popRecord(experiment) {
      var self = this;      
      self.getBoardExperimentStart(experiment, "set_0");
      self.getBoardExperimentStart(experiment, "set_1");
      self.getBoardExperimentStart(experiment, "set_2");
      self.getBoardExperimentStart(experiment, "set_3");
      setTimeout(function(){
        if (experiment == "RESPIRATION") {
          self.selected_experiment = "RESPIRATION";
          self.recordDialog = true;
        } else if (experiment == "PHOTOSYNTHESIS") {
          self.selected_experiment = "PHOTOSYNTHESIS";
          self.recordDialog = true;
        } else {
          self.selected_experiment = "";
          self.recordDialog = false;
        }
      },200);
      
    },
    downloadCSV(experiment, equipment_id) {
      var self = this;
      window.open(
        process.env.VUE_APP_BASE_URL +
          "/api/experiment/storage/" +
          experiment +
          "-"+
          equipment_id+
          ".csv"
      );
    },
    removeAllData(experiment, equipment_id) {
      var self = this;
      apiService.removeBoardRecords(
        experiment,
        equipment_id,
        "device_0",
        function () {
          alert("Removed all Data of " + experiment + "-" + equipment_id);
        }
      );
    },
    getImageSrc(experiment, equipment_id, light) {
      var self = this;
      var on_off = '';
      if(light==0){
        on_off = "off";
      }
      else if (light==1){
        on_off = "on";
      }
/*      self.api.img_src =
        process.env.VUE_APP_BASE_URL +
        "/api/experiment/storage/"+experiment+"-"+equipment_id+"-setup-"+on_off+".jpg";
        console.log(self.api.img_src);
      self.image_select = true;
*/    
      self.getBoardPhotoName(experiment, equipment_id, on_off);

    },
    closeDialog() {
      var self = this;
      self.imageDialog = false;
      self.recordDialog = false;
      self.conditionDialog = false;
      self.dataDialog = false;
      self.lightDialog = false;
      self.condition_select = false;
      self.image_select = false;
      self.selected_experiment = "";
      self.selected_light = "";
      self.equipment_id = "";   
      self.api.img_src = "";   
    },
    uploadFile: function () {
      var self = this;
      let fileInputElement = this.$refs.file;
      fileInputElement.click();
    },
    removePhoto(experiment, equipment_id, light) {
      var self = this;
      var on_off = "";
      if(light==0){
        on_off = "off";
      }
      else if (light==1){
        on_off = "on";
      }
      apiService.removeExperimentPhoto(experiment, equipment_id, on_off, function () {
        alert("Removed Experiment Photo");
        self.getImageSrc(experiment, equipment_id, light)
      });
    },
    uploadPhoto() {
      this.file = this.$refs.file.files[0];
      this.uploadExperimentPhoto(this.selected_experiment, this.equipment_id, this.selected_light, this.file);
    },
    uploadExperimentPhoto(experiment,equipment_id, light, file) {
      var on_off = "";
      if(light==0){
        on_off = "off";
      }
      else if (light==1){
        on_off = "on";
      }
      apiService
        .uploadExperimentPhoto(experiment, equipment_id, on_off, file)
        .then((response) => {
          if (response.status == "success") {
            alert("New experiment photo uploaded successfully");
            if (experiment == "RESPIRATION") {
              this.respiration_img_src = "";
            } else if (experiment == "PHOTOSYNTHESIS") {
              this.photosynthesis_img_src = "";
            }
            this.getImageSrc(experiment, equipment_id, on_off);
            window.location.reload();
          } else if (response.status == "wrong_type") {
            alert("Fail. Please upload a image file");
          } else if (response.status == "fail") {
            alert("Fail. Error in uploading experiment photo");
          }
        });
    },
    startRecord(experiment, equipment_id) {
      var self = this;
      apiService.startRecord(experiment, equipment_id).then((response) => {
        if (response.status == "success") {          
          self.api.records[equipment_id] = 1;
        } else if (response.status == "fail") {
          alert(response.error);
        }
      });
      
    },
    stopRecord(experiment, equipment_id) {
      var self = this;
      apiService.stopRecord(experiment, equipment_id).then((response) => {
        if (response.status == "success") {
          self.api.records[equipment_id] = 0;
        } else if (response.status == "fail") {
          alert(response.error);
        }
      });
    },
    lightOn(experiment, equipment_id) {
      var self = this;
      apiService.lightOn(experiment, equipment_id).then((response) => {
        if (response.status == "success") {          
          self.api.lights[equipment_id] = 1;
        } else if (response.status == "fail") {
          alert(response.error);
        }
      });
      
    },
    lightOff(experiment, equipment_id) {
      var self = this;
      apiService.lightOff(experiment, equipment_id).then((response) => {
        if (response.status == "success") {
          self.api.lights[equipment_id] = 0;
        } else if (response.status == "fail") {
          alert(response.error);
        }
      });
    },
    getBoardExperimentStart(experiment, equipment_id, callback) {
      var self = this;
      apiService
        .getBoardExperimentStart(experiment, equipment_id)
        .then((response) => {
          self.api.records[equipment_id] = response.board_start;
          if (callback) {
            callback();
          }
        });
    },
    getBoardExperimentLight(experiment, equipment_id, callback) {
      var self = this;
      apiService
        .getBoardExperimentLight(experiment, equipment_id)
        .then((response) => {
          self.api.lights[equipment_id] = response.light_on;
          if (callback) {
            callback();
          }
        });
    },

    promptRemove(experiment, equipment_id) {
      this.confirmRemoveDialog = true;
      this.experiment = experiment;
      this.equipment_id = equipment_id;
      console.log(this.experiment, this.equipment_id);
    },
    confirmRemove() {
      this.removeAllData(this.experiment, this.equipment_id);
      this.confirmRemoveDialog = false;
    },
    cancelRemove() {
      this.experiment = "";
      this.confirmRemoveDialog = false;
    },
    promptStop(experiment, equipment_id) {
      this.confirmDialog = true;
      this.experiment = experiment;
      this.equipment_id = equipment_id;
    },
    confirmStop() {
      this.stopRecord(this.experiment, this.equipment_id);
      this.confirmDialog = false;
    },
    cancelStop() {
      this.experiment = "";
      this.equipment_id = "";
      this.confirmDialog = false;
    },
    popCondition(experiment) {
      var self = this;
      self.selected_experiment = experiment;
      self.conditionDialog = true;      
    },
    getCondition(equipment_id){
      var self = this;
      self.equipment_id = equipment_id;
      apiService
        .getCondition(self.selected_experiment, equipment_id)
        .then((response) => {
          self.api.condition = JSON.parse(response.value);
          self.condition_select = true;
          setTimeout(function(){
            self.$refs.emptyInput.forEach((value) => {
              value.$refs.input.value="";
              console.log(value);
            });
          },100);
        });
    },
    undoChanges(){
      var self = this;
      console.log(self.equipment_id);
      self.getCondition(self.equipment_id);
    },
    generateChanges(){
      var self = this;
      var inputs = self.$refs.input;
      self.arr = [];
      var promise = new Promise((resolve, reject) => {
        var count = inputs.length;console.log(count);
        var temp = "";
        var store = 0;
        inputs.forEach((value, index, array) => {
          //temp.push({});
          if(index%2==0){            
            store = 0;
            if(value.$refs.input.value.trim()==""){              
              store += 1;
            }
            temp = '{"key":"' + value.$refs.input.value + '",';
          }
          else if(index%2==1){
            if(value.$refs.input.value.trim()==""){              
              store += 1;
            }
            temp += '"value":"' + value.$refs.input.value + '"}';
            if(store<2){
              self.arr.push(temp);
            }
          }          
          if (index === array.length -1){            
            resolve();
          }          
        })
      }).then(function(){        
        apiService
        .setCondition(self.selected_experiment, self.equipment_id, self.arr)
        .then((response) => {
          if(response.status=="success") {
            alert("Condition of "+self.selected_experiment+" ("+ self.equipment_id+") has been updated.");
            getCondition(self.equipment_id);
          }
          else if(response.status=="fail") {
            alert(response.error);
          }
        });
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>